import RespondentsConsumerAllInstantLuckyDrawPanel from './respondentsConsumerAllInstantLuckyDrawPanel.container'

export default RespondentsConsumerAllInstantLuckyDrawPanel